import React from 'react';
import { useTranslation } from 'react-i18next';
import Template from '../component/template';
import Dashboard from '../component/dashboard';
 
const Home = () => {
    const { t } = useTranslation();
    
    return (
        <Template>
            GREEN ENERGY & CONSTRUCTION 
 
        </Template>
    );
}

export default Home;
